import React, { useState } from "react";
import { FiCamera } from "react-icons/fi";
import ReactCrop from "react-image-crop";

import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { Button, Col, Modal, Row } from "react-bootstrap";

const CropImageModal = ({
  image = null,
  src = "",
  crop = { aspect: 1 / 1 },
  onCrop = () => {},
  onChangeInput = () => {},
  onChangeCrop = () => {},
  onImageLoaded = () => {},
}) => {
  const [show, setShow] = useState(false);

  const onHide = () => {
    setShow(false);
  };

  const onChange = (event) => {
    onChangeInput(event);
    setShow(true);
  };

  const cropImage = () => {
    onCrop();
    setShow(false);
  };

  return (
    <>
      <div className="uploadFileBtn">
        <label htmlFor="upload-single-file">
          <FiCamera size="18" color="#00b5ef" />
        </label>
        <input
          className="uploadFile"
          onChange={onChange}
          id="upload-single-file"
          type="file"
          accept="image/*"
        />
      </div>
      <div className="d-flex align-items-center">
        <Modal size="md" show={show} onHide={onHide}>
          <div className="card" style={{ overflow: "visible" }}>
            <div className="card-body">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-1">Crop Image</h3>
              </div>
              <Row className="mb-3">
                <Col md="12">
                  <div className="logoCrop mb-2 mt-2">
                    <ReactCrop
                      src={src}
                      crop={crop}
                      circularCrop={false}
                      onImageLoaded={onImageLoaded}
                      onChange={onChangeCrop}
                    />
                  </div>
                </Col>
              </Row>
              <div className="mt-2 text-center">
                <Button onClick={onHide} className="btn btn-secondary mr-2">
                  Close
                </Button>
                <Button onClick={cropImage} className="btn-rounded">
                  Crop Image
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        <div className="mr-3">
          {src ? (
            <img className="img-thumbnail companyLogo" src={src} alt="cropped-img" />
          ) : (
            image && (
              <img
                className="img-thumbnail companyLogo"
                src={URL_CONFIG.IMG_URL + image.document_name}
                alt="signature"
              />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default CropImageModal;
